module.exports = "::ng-deep .custom-tooltip {\n\tfont-size: 14px;\n\tbackground: #6ee229;\n}\n\n.address_link {\n\ttext-decoration: none;\n}\n\n.link_arrows {\n\ttop: 7px;\n    left: -4px;\n    position: relative;\n}\n\n.info-section{\n\tmargin-top: 16px;\n\tborder: solid 1px black !important;\n    background: white !important;\n}\n\n.half-width.right{\n\tmargin-left: 2px;\n}\n\nh4.additional_info{\n\tmargin-bottom: 0;\n}"


//////////////////
// WEBPACK FOOTER
// ./src/app/profile/account-setting/account-setting.component.css
// module id = ./src/app/profile/account-setting/account-setting.component.css
// module chunks = main